// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-theme-gallery-src-pages-index-tsx": () => import("./../node_modules/gatsby-theme-gallery/src/pages/index.tsx" /* webpackChunkName: "component---node-modules-gatsby-theme-gallery-src-pages-index-tsx" */)
}

